import React from "react";
import { Icon } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import cx from "classnames";

import styles from "./back.module.scss";

export default function Back(props) {
  const history = useHistory();

  return (
    <>
      <div
        className={cx(styles.back)}
        onClick={(e) => {
          e.preventDefault();
          history.push(props.path);
        }}
      >
        <Icon name="arrow left" />
        <span> Back </span>
      </div>
    </>
  );
}
